import styled from 'styled-components'

export const ShowAlignmentRowsContainer = styled.div`
  margin-top: 11px;
  margin-bottom: 11px;
`
